import { createSlice } from '@reduxjs/toolkit'
import { getCampaignMaster, getCampaigns, getCampaignStatistics, getCampaignTypes } from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState = { 
  campaignData: {
    pageIndex: 0,
    totalRecords: 10,
    totalPages: 1,
    pageSize: 10,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: [],
    numElements: 15
  }, 
  campaignStatistics: {
    pageIndex: 0,
    totalRecords: 10,
    totalPages: 1,
    pageSize: 15,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: [],
    numElements: 15
  },
  campaignMaster:[],
  campaignTypes: [],
  loading: "idle",
  loadingTypes: "idle",
  loadingStatistics: "idle",
  loadingMaster: "idle",
  error: null 
}

const campaignSlice = createSlice({
  name: 'campaigns',
  initialState,
  reducers: {
    clearcampaignError: (state) => {
      state.error = null
      state.loading = "idle"
    },
    setStatisticFilters:(state, action)=>{
      state.statisticFilters = action.payload;
    }
  },
  extraReducers: {
    [getCampaigns.pending]: (state) => {
      state.loading = "loading"; 
      state.error = null
    },
    [getCampaigns.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      state.campaignData = action.payload;
    },
    [getCampaigns.rejected]: (state, action) => {
      state.loading = "failed"; 
      state.error = action.error.message
    },
    [getCampaignTypes.pending]: (state)=>{
      state.loadingTypes = "loading";
      state.error = null;
    },
    [getCampaignTypes.fulfilled]: (state, action)=>{
      state.loadingTypes = "succeeded";
      state.campaignTypes = action.payload;
    },
    [getCampaignTypes.rejected]: (state, action) => {
      state.loadingTypes = "failed"; 
      state.error = action.error.message
    },
    [getCampaignStatistics.pending]: (state) => {
      state.loadingStatistics = "loading"; 
      state.error = null
    },
    [getCampaignStatistics.fulfilled]: (state, action) => {
      state.loadingStatistics = "succeeded";
      state.campaignStatistics = action.payload;
    },
    [getCampaignStatistics.rejected]: (state, action) => {
      state.loadingStatistics = "failed"; 
      state.error = action.error.message
    },
    [getCampaignMaster.pending]: (state)=>{
      state.loadingMaster = "loading";
      state.error = null;
    },
    [getCampaignMaster.fulfilled]: (state, action)=>{
      state.loadingMaster = "succeeded";
      state.campaignMaster = action.payload;
    },
    [getCampaignMaster.rejected]: (state, action) => {
      state.loadingMaster = "failed"; 
      state.error = action.error.message
    },
    [logOut]: (state)=> initialState
  }
})

export const {clearcampaignError, setStatisticFilters} = campaignSlice.actions;
export default campaignSlice.reducer